module.exports = __webpack_public_path__ + "img/Modify-Deal.5db14e4b.svg";